/* eslint-disable */
const FilterFields = {
    alldays: Array.from({ length: 30 }, (_, i) => i + 1).map(day => ({
      label: `${day}`,
      value: `${day}`
    })),
    allHours: Array.from({ length: 24 }, (_, i) => i + 1).map(hour => ({
      label: `${hour-1}`,
      value: `${hour-1}`
    })),
  };
  
  export default FilterFields;
